import { Box, FlexBox, Stack } from '@ardoq/layout';
import { Header4, Text } from '@ardoq/typography';

type CenteredMessageProps = {
  title: string;
  description: string;
};

export const CenteredMessage = ({
  title,
  description,
}: CenteredMessageProps) => (
  <FlexBox justify="center" align="center" width="full" height="full">
    <Box padding="large">
      <Stack gap="small" align="center">
        <Header4>{title}</Header4>
        <Text variant="text2" color="textSubtle">
          {description}
        </Text>
      </Stack>
    </Box>
  </FlexBox>
);
